module.exports = __webpack_public_path__ + "static/media/protocol-blue.5e2a56ad.svg";